import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/more.svg'


const _hoisted_1 = { class: "dashboard-table" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex mb-3"
}
const _hoisted_3 = { class: "search-input input-group ms-auto" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "table" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn-link dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, "No data", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "d-flex flex-row" }
const _hoisted_18 = {
  key: 0,
  class: "pagination ms-auto"
}
const _hoisted_19 = { class: "page-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "«", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "page-item" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "»", -1)
const _hoisted_25 = [
  _hoisted_24
]

import { Dictionary } from "@/classes/interfaces/dictionary";


export interface RowOption {
	actionName: string;
	action(data:any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardTable',
  props: {
	columns: { // names of columns
		type: Array,
		default(){
			return [] as Array<string>
		}
	},
	data: { //2d array of preformatted data
		type: Array,
		default(){
			return [] as Array<any>
		}
	},
	currentPage: {
		type: Number,
		default: 0
	},
	pageCount: {
		type: Number,
		default: 1
	},
	//Key is index of column, number is 
	//-1: for descending sorting 
	// 0: for default
	// 1: for ascending sorting
	sortableColumns:{
		type: Object,
		default(){
			return {} as Dictionary<number> 
		}
	},
	showSearch: {
		type: Boolean,
		default: false
	},
	searchString: {
		type: String,
		default: null
	},
	rowActions: {
		type: Array,
		default(){
			return [] as Array<RowOption>
		}
	}
},
  emits: ["onSearch", "onPageChanged", "onSortChanged", "onRowClick"],
  setup(__props, { emit }) {

const props = __props;






function getSortDirectionForColumn(index: number): string{
	const sortOrder = props.sortableColumns[index.toString()]
	if(sortOrder === undefined || sortOrder == 0){
		return ""
	}else if(sortOrder < 0){
		return "asc";
	}else{
		return "desc";
	}
}

function isSortable(index: number): boolean{
	return props.sortableColumns[index.toString()] !== undefined;
}

function isSortEnabled(index: number): boolean{
	const sortOrder = props.sortableColumns[index.toString()];
	return sortOrder > 0 || sortOrder < 0;
}

function onPageChanged(page: number){
	emit("onPageChanged", page);
}

function toggleSortColumn(index){
	const currentValue = props.sortableColumns[index.toString()]
	if(currentValue !== undefined){
		let nextValue = currentValue+1;
		if(nextValue > 1){
			nextValue = -1;
		}
		emit("onSortChanged", index, nextValue);
	}
}

function onRowClick(data: any){
	emit("onRowClick", data);
}

function onSearch(event: any){
	emit("onSearch",event.target.value);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.showSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search...",
              value: props.searchString,
              onInput: onSearch,
              "aria-label": "Search"
            }, null, 40, _hoisted_4)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_5, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column, index) => {
            return (_openBlock(), _createElementBlock("th", {
              key: index,
              onClick: ($event: any) => (toggleSortColumn(index)),
              class: _normalizeClass({'sorted': isSortEnabled(index)})
            }, [
              _createTextVNode(_toDisplayString(column) + " ", 1),
              (isSortable(index))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["sort-direction", [getSortDirectionForColumn(index)]])
                  }, null, 2))
                : _createCommentVNode("", true)
            ], 10, _hoisted_6))
          }), 128)),
          (props.rowActions.length > 0)
            ? (_openBlock(), _createElementBlock("th", _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (row, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            onClick: ($event: any) => (onRowClick(row))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (value, index) => {
              return (_openBlock(), _createElementBlock("td", {
                key: index,
                class: _normalizeClass({'sorted': isSortEnabled(index)})
              }, _toDisplayString(value), 3))
            }), 128)),
            (props.rowActions.length > 0)
              ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rowActions, (action, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (action.action(row))
                          }, _toDisplayString(action.actionName), 9, _hoisted_13)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_8))
        }), 128)),
        (!props.data || props.data.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (props.pageCount > 1)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
            _createElementVNode("li", _hoisted_19, [
              (props.currentPage > 0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "page-link",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onPageChanged(props.currentPage-1))),
                    "aria-label": "Previous"
                  }, _hoisted_21))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.pageCount, (index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "page-item"
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass(["page-link", {'active' : (index - 1) === props.currentPage}]),
                  href: "#",
                  onClick: ($event: any) => (onPageChanged(index-1))
                }, _toDisplayString(index), 11, _hoisted_22)
              ]))
            }), 128)),
            _createElementVNode("li", _hoisted_23, [
              (props.currentPage !== props.pageCount)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "page-link",
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (onPageChanged(props.currentPage+1))),
                    "aria-label": "Next"
                  }, _hoisted_25))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})